var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSideArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.775 18.2354C9.59167 18.052 9.5 17.8187 9.5 17.5354C9.5 17.252 9.59167 17.0187 9.775 16.8354L13.675 12.9354L9.775 9.03535C9.59167 8.85202 9.5 8.61868 9.5 8.33535C9.5 8.05202 9.59167 7.81868 9.775 7.63535C9.95833 7.45202 10.1917 7.36035 10.475 7.36035C10.7583 7.36035 10.9917 7.45202 11.175 7.63535L15.775 12.2354C15.875 12.3354 15.946 12.4437 15.988 12.5604C16.0293 12.677 16.05 12.802 16.05 12.9354C16.05 13.0687 16.0293 13.1937 15.988 13.3104C15.946 13.427 15.875 13.5354 15.775 13.6354L11.175 18.2354C10.9917 18.4187 10.7583 18.5104 10.475 18.5104C10.1917 18.5104 9.95833 18.4187 9.775 18.2354Z",
    fill: "#E5E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideArrow);
export default __webpack_public_path__ + "static/media/side-arrow.6485192e2ecdb8431a2dc8dcf4789317.svg";
export { ForwardRef as ReactComponent };